// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function placeholderFromProductKind(kind) {
  if (kind === "SPIRITUOUS") {
    return "0,7L - 10 " + I18n.t("years");
  } else if (kind === "BEER") {
    return "0,33L";
  } else if (kind === "WINE") {
    return "0,75L - 2017";
  } else {
    return "0,5kg";
  }
}

function make(productKind, capacityValue, capacityUnit, bulk, year) {
  return (
    capacityUnit !== undefined ? (
        bulk ? I18n.template(I18n.t("Bulk by {{unit}}"), {
            unit: capacityUnit
          }, undefined) : (
            capacityValue !== undefined ? capacityValue.toString() + capacityUnit : ""
          )
      ) + Stdlib_Option.mapOr(year, "", year => {
        let separator = Stdlib_Option.isSome(capacityValue) || bulk ? " - " : "";
        let relativeYear = year.toString();
        if (productKind !== "SPIRITUOUS") {
          return separator + relativeYear;
        }
        let yearWord = year > 1 ? I18n.t("years") : I18n.t("year");
        return separator + relativeYear + " " + yearWord;
      }) : (
        bulk ? "" : I18n.t("Piece")
      )
  ).replace(".", ",");
}

let Name = {
  placeholderFromProductKind: placeholderFromProductKind,
  make: make
};

let kg = "kg";

let g = "g";

let l = "L";

let cl = "cL";

let ml = "mL";

function getDefaultFromProductKind(productKind) {
  if (productKind === "SIMPLE") {
    return kg;
  } else {
    return l;
  }
}

function makeOptions(productKind) {
  if (productKind === "WINE" || productKind === "SPIRITUOUS") {
    return [
      l,
      cl
    ];
  } else if (productKind === "BEER") {
    return [
      l,
      cl,
      ml
    ];
  } else {
    return [
      kg,
      g,
      l,
      cl,
      ml
    ];
  }
}

let CapacityUnit = {
  kg: kg,
  g: g,
  l: l,
  cl: cl,
  ml: ml,
  getDefaultFromProductKind: getDefaultFromProductKind,
  makeOptions: makeOptions
};

function placeholderFromProductKind$1(kind) {
  if (kind === "SPIRITUOUS") {
    return "0,70";
  } else if (kind === "BEER") {
    return "0,33";
  } else if (kind === "WINE") {
    return "0,75";
  } else {
    return "0,50";
  }
}

let CapacityValue = {
  placeholderFromProductKind: placeholderFromProductKind$1
};

function placeholderFromProductKind$2(kind) {
  if (kind === "SPIRITUOUS") {
    return "10";
  } else if (kind !== "WINE") {
    return "";
  } else {
    return "2017";
  }
}

let Year = {
  placeholderFromProductKind: placeholderFromProductKind$2
};

function placeholderFromProductKind$3(kind) {
  if (kind === "SPIRITUOUS") {
    return "42,00";
  } else if (kind === "BEER") {
    return "4,50";
  } else if (kind === "WINE") {
    return "13,10";
  } else {
    return "";
  }
}

let Volume = {
  placeholderFromProductKind: placeholderFromProductKind$3
};

function arrayKeepUniqueBy(collection, predicate) {
  return collection.filter((current, index) => Stdlib_Array.findIndexOpt(collection, element => predicate(element, current)) === index);
}

function isReferenceDiffering(shopsReference, scope, predicate) {
  let match = arrayKeepUniqueBy(shopsReference, predicate);
  if (scope.TAG === "Organisation" && scope.activeShop === undefined) {
    return match.length > 1;
  } else {
    return false;
  }
}

let MultiShops = {
  arrayKeepUniqueBy: arrayKeepUniqueBy,
  isReferenceDiffering: isReferenceDiffering
};

function format(rawValue, capacityPrecision, capacityUnit) {
  return (
    capacityPrecision !== undefined ? rawValue / Math.pow(10, capacityPrecision) : rawValue
  ).toString().replace(".", ",") + (
    capacityUnit !== undefined ? capacityUnit : ""
  );
}

let StockQuantity = {
  format: format
};

let defaultBulkCapacityPrecision = 3;

export {
  defaultBulkCapacityPrecision,
  Name,
  CapacityUnit,
  CapacityValue,
  Year,
  Volume,
  MultiShops,
  StockQuantity,
}
/* I18n Not a pure module */
